import { createFileRoute } from '@tanstack/react-router';
import { PostOnInstagram } from '@/pages';

/**
 * Post on Instagram Route (Protected)
 * Social task submission screen for a single campaign deliverable task.
 */
export const Route = createFileRoute('/_authenticated/campaign/$id/tasks_/$taskId')({
  component: PostOnInstagram,
});
